import { css, SerializedStyles } from '@emotion/react'
import styled from '@emotion/styled'
import { colors } from 'parameters/ui'
import { WidgetWrapper } from 'components/content/CrossSell/Basic'

export const NoStyle = css``
export const CardStyle = css`
	box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
	border-radius: 8px;
	padding: 24px;
	background: ${colors.white};
`

interface Props {
	cardStyle?: SerializedStyles
	columns?: number
}
export const CardBoundary = styled.div<Props>`
	min-height: 380px;
	min-width: 280px;
	width: 100%;
	display: flex;
	// I have no idea if this is a good idea or not
	${props => props.cardStyle}
	grid-column: span ${props => props.columns || 1};
	// This doesnt make this ok
	${WidgetWrapper} {
		height: unset;
	}
`

export const CardLayoutWrapper = styled.div`
	text-align: center;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
	display: flex;
	flex: auto;

	> a,
	button {
		width: 100%;
	}
`

export const CardTitle = styled.p`
	font-weight: bold;
	font-size: 22px;
	line-height: 29px;
	margin: 24px 0;
`

export const CardContent = styled.div`
	display: flex;
	flex-grow: 1;
	align-items: flex-start;
`

export const TagsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	max-width: 480px;
	margin: 32px auto 0;
	justify-content: center;

	button {
		margin: 5px;
	}
`

export const AnchorWrapper = styled.div`
	height: 48px;
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
`
